export const stripePromise = "pk_live_21JP8aOXEKM5PPRgAL4Env7E00xfFR9JeT";
// export const stripePromise = "pk_test_gFpfss2M2HcQp17Dz760omdB00mKDoBblM";
